import { getContactsInfo } from '~/api/contacts'
import { CityPrice } from '~~/types/api'
import { Location } from '~~/types/types'
import {useCityStore} from '~/stores/city';
import {storeToRefs} from 'pinia';

export const usePopularDirectionsStore = defineStore('popular-directions', () => {
  const {locationByGuid} = useCityStore()
  const {from, to} = storeToRefs(useCityStore())

  const oneLocation = ref<Location>(from.value)
  const twoLocation = ref<Location>(to.value) // используется только для режима работы - two-location-editable, когда можем редактировать оба направления

  const directionsFrom = ref<CityPrice[]>()
  const directionsTo = ref<CityPrice[]>()

  async function updatePopularDirections(location: string, direction: string, destination: any): Promise<any> {
    const isFrom = direction === 'from'
    const dest = isFrom ? destination : undefined
    const directions = await getContactsInfo(location, dest)

    if (isFrom) {
      directionsFrom.value = directions.price_from
    } else {
      directionsTo.value = directions.price_to
    }
  }

  async function changeOneLocation(guid: string) {
    oneLocation.value = await locationByGuid(guid)
  }

  async function changeTwoLocation(guid: string) {
    twoLocation.value = await locationByGuid(guid)
  }

  watch(() => from.value, () => {
    oneLocation.value = from.value
  })

  watch(() => to.value, () => {
    twoLocation.value = to.value
  })

  return {
    oneLocation,
    twoLocation,
    directionsFrom,
    directionsTo,
    updatePopularDirections,
    changeOneLocation,
    changeTwoLocation
  }
})
